// extracted by mini-css-extract-plugin
export default {"disabledFormOverlay":"mIcATt"};